// UserProfileJsonLd.js
import { connect } from 'react-redux';

import UserProfileJsonLd from '../component/UserProfileJsonLd.jsx';
import getUserData from '../selector/getUserData.js';
import getMessageList from '../selector/getMessageList.js';
import getMessageDataList from '../selector/getMessageDataList.js';
import { ProfileListType } from '../resource/profileConstants.js';

const mapStateToProps = (state, { userId }) => {
  const storyListSelectPath = ['outbox', ProfileListType.STORY, userId];
  const flixListSelectPath = ['outbox', ProfileListType.FLIX, userId];
  const storyIds = getMessageList(
    state,
    'outbox',
    storyListSelectPath,
    'itemIds'
  );
  const flixIds = getMessageList(
    state,
    'outbox',
    flixListSelectPath,
    'itemIds'
  );
  return {
    userId,
    username: getUserData(state, userId, 'username'),
    biography: getUserData(state, userId, 'biography'),
    storyDataList: getMessageDataList(state, storyIds),
    flixDataList: getMessageDataList(state, flixIds),
  };
};

export default connect(mapStateToProps)(UserProfileJsonLd);
